export default "__VITE_ASSET__cfqA8TNU__"